<template>
  <div 
    ref="trustBoxRef" 
    class="trustpilot-widget" 
    data-locale="en-GB"
    data-template-id="54ad5defc6454f065c28af8b"
    data-businessunit-id="4d8102bb00006400050f1f52"
    data-style-height="200px" 
    data-style-width="100%"
    data-stars="4,5" 
    data-review-languages="en" 
    :data-tags="tag || null" 
    data-font-family="Rubik">
    <a href="https://uk.trustpilot.com/review/www.brickhunter.com" target="_blank" rel="noopener noreferrer">
      <slot />
    </a>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

defineProps({
  tag: {
    type: String,
    required: true,
  },
});

const trustBoxRef = ref(null);

onMounted(() => {
  const script = document.getElementById('trustpilot-widget-script');
  if (window.Trustpilot && trustBoxRef.value) {
    window.Trustpilot.loadFromElement(trustBoxRef.value, true);
  } else if (script) {
    script.addEventListener('load', () => {
      if (window.Trustpilot && trustBoxRef.value) {
        window.Trustpilot.loadFromElement(trustBoxRef.value, true);
      }
    });
  }
});
</script>
